import { createStore } from 'vuex';

const store = createStore({
    state: {
        isLoggedIn: false,
        loggedUser: null,
        isOpenAside: true,
        jwtToken: null,
        noOfNotifications: 0,
        isDarkMode: false,
		userModules: [],
		modulesLoadedForUserId: null,
    },
    mutations: {
        setToggleDarkMode(state, value) {
            state.isDarkMode = value;
        },
        setIsLoggedIn(state, value) {
            state.isLoggedIn = value;
        },
        setLoggedUser(state, value) {
			if (!value || Number(state.loggedUser?.id) !== Number(value.id)) {
				state.userModules = [];
				state.modulesLoadedForUserId = null;
			}
            state.loggedUser = value;
        },
		setUserModules(state, { userId, modules }) {
			state.userModules = Array.isArray(modules) ? modules : [];
			state.modulesLoadedForUserId = Number(userId);
		},
        setToggleAsideMenu(state, value){
            state.isOpenAside = value;
        },
        setJWTToken(state, value){
            state.jwtToken = value;
        },
        setNoOfNotifications(state, value){
            state.noOfNotifications = value;
        },
    },
});

// Load state from local storage on store initialization
const storedState = JSON.parse(localStorage.getItem('user_state'));
if (storedState) {
    store.replaceState({ ...store.state, ...storedState });
	// Role assignments can change between browser sessions; always verify them again.
	store.state.userModules = [];
	store.state.modulesLoadedForUserId = null;
}

// Save state to local storage whenever a mutation occurs
store.subscribe((mutation, state) => {
    localStorage.setItem('user_state', JSON.stringify(state));
});

export default store;
